import { render, staticRenderFns } from "./LeadPageAddOrEdit.vue?vue&type=template&id=115b558a&scoped=true"
import script from "./LeadPageAddOrEdit.vue?vue&type=script&lang=js"
export * from "./LeadPageAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LeadPageAddOrEdit.vue?vue&type=style&index=0&id=115b558a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b558a",
  null
  
)

export default component.exports